/**This component is to display the alerts in different categories */
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./NewAnnouncementsForm.css";
import { getcategories, getcategoryalldata } from "../../../../Services/EndPoints";
import { ReactComponent as SearchIcon } from '../../../../Assets/Icons/search.svg';
import { getData } from "../../../../Services/Services";
import AlertModal from "./AlertModal";
import { format } from 'date-fns';

const NewAnnouncementsForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]); // Changed to array for multi-select
  const [AllCategoryData, setAllCategoryData] = useState([]);
  const [searchText, setSearchText] = useState('');
  // State for the card details modal
  const [showCardModal, setShowCardModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    fetchcategory();
    fetchallData();
  }, []);

  const fetchcategory = async () => {
    try {
      const response = await getData(getcategories);
      if (response && Array.isArray(response)) {
        setCategories(response);
      } else {
        toast.error("Failed to load categories data");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchallData = async () => {
    try {
      const response = await getData(getcategoryalldata);
      if (response && Array.isArray(response)) {
        setAllCategoryData(response);
      } else {
        toast.error("Failed to load categories data");
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  // Handle checkbox change for multi-select categories
  const handleCategoryChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    
    if (checked) {
      setSelectedCategories([...selectedCategories, value]);
    } else {
      setSelectedCategories(selectedCategories.filter(cat => cat !== value));
    }
  };

  // Handle modal close and data refresh
  const handleModalClose = () => {
    setShowModal(false);
  };

  // Callback for when alert is successfully created
  const handleAlertSuccess = () => {
    fetchallData(); // Refresh data after successful alert creation
  };

  // Function to handle card click
  const handleCardClick = (card) => {
    setSelectedCard(card);
    setShowCardModal(true);
  };

  function formatDate(dateStr) {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return format(date, 'dd MMMM yyyy'); // e.g. "30 May 2025"
    } catch {
      return dateStr; // fallback in case of invalid date
    }
  }

  // Close the card details modal
  const handleCardModalClose = () => {
    setShowCardModal(false);
    setSelectedCard(null);
  };

  
  const getBranchesData = () => {
    const branchesCategory = AllCategoryData.find(cat => cat.categoryName === "BRANCHES");
    return branchesCategory?.list || [];
  };

  const getIncidentsData = () => {
    const incidentsCategory = AllCategoryData.find(cat => cat.categoryName === "INCIDENTS");
    return incidentsCategory?.list || [];
  };

  const getAtmData = () => {
    const atmCategory = AllCategoryData.find(cat => cat.categoryName === "ATMS");
    return atmCategory?.list || [];
  };

  const getStaffData = () => {
    const staffCategory = AllCategoryData.find(cat => cat.categoryName === "STAFF");
    return staffCategory?.list || [];
  };

  // Function to filter data based on selected categories and search text
  const filteredData = (selectedCategories, searchText) => {
    const filterBySearchText = (data) => {
      if (!searchText) return data; // Return all if no search
      return data.filter(item =>
        item.title.toLowerCase().includes(searchText.toLowerCase()) ||
        item.description.toLowerCase().includes(searchText.toLowerCase())
      );
    };
  
    const branchesData = filterBySearchText(getBranchesData());
    const incidentsData = filterBySearchText(getIncidentsData());
    const atmData = filterBySearchText(getAtmData());
    const staffData = filterBySearchText(getStaffData());
  
    return {
      branches: selectedCategories.length === 0 || selectedCategories.includes('BRANCHES') ? branchesData : [],
      incidents: selectedCategories.length === 0 || selectedCategories.includes('INCIDENTS') ? incidentsData : [],
      atm: selectedCategories.length === 0 || selectedCategories.includes('ATMS') ? atmData : [],
      staff: selectedCategories.length === 0 || selectedCategories.includes('STAFF') ? staffData : [],
    };
  };

  const { branches, incidents, atm, staff } = filteredData(selectedCategories, searchText);

  // Use a fixed column width for consistent layout
  const columnClass = "col-md-3"; // Always use quarter width for all columns

  // Helper function to get background color class based on subCategoryName and category
  const getBackgroundClass = (subCategoryName, category) => {
    if (category === "BRANCHES") {
      return subCategoryName === 'Staff' ? 'bg-staff' : 'bg-gray';
    } else if (category === "INCIDENTS") {
      if (subCategoryName === 'Fire') return 'bg-staff1';
      if (subCategoryName === 'Fraud') return 'bg-gray2';
      return 'bg-gray1';
    } else if (category === "ATMS") {
      return subCategoryName === 'Machine' ? 'bg-atm' : 'bg-atm1';
    } else if (category === "STAFF") {
      return subCategoryName === 'Requirement' ? 'bg-req' : 'bg-req1';
    }
    return 'bg-gray';
  };

  // Card component to avoid repetition
  const AnnouncementCard = ({ item, category }) => (
    <div 
      className="card mb-2 rounded-white-card" 
      onClick={() => handleCardClick({...item, categoryName: category})}
      style={{ cursor: 'pointer' }}
    >
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span
            className={`titlehead ${getBackgroundClass(item.subCategoryName, category)}`}
            style={{ fontSize: '12px', fontWeight: '400', fontFamily: 'Poppins' }}
          > 
            {item.subCategoryName}
          </span>
          <span className="text-primary1">{formatDate(item.activeDate)}</span>
        </div>
        <h6 className="card-title custom-title">{item.title}</h6>
        <p className="card-text custom-location">{item.description}</p>
      </div>
    </div>
  );

  return (
    <div style={{ backgroundColor: '#D8D8D81F' }}>
      <div style={{
        backgroundColor: '#ffffff',
        padding: '8px',
        borderBottom: '1px solid #fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height:"41px"
      }}>
        <div style={{ fontSize: '15px', color: '#809FB8' , marginRight: "5px"}}>
          New Announcements
        </div>

        <button style={{
          // padding: '10px',
          backgroundColor: '#1a7a73',
          color: '#fff',
          border: 'none',
          borderRadius: '7px',
          cursor: 'pointer',
          fontFamily: 'Poppins',
          fontSize: '15px',
          height: '29px',
          paddingLeft: "7px",
          paddingRight: "7px"
        }} onClick={() => setShowModal(true)}>
          Create Announcement
        </button>

        {/* Component to create new announcement */}
        <AlertModal
          show={showModal}
          onClose={handleModalClose}
          onSuccess={handleAlertSuccess}
        />
      </div>

      <div className="branch-main-container">
        <div className="d-flex align-items-center gap-2" style={{ marginTop: 2, marginRight: 10 }}>
          {/* Multi-select dropdown for categories */}
          <div className="dropdown">
            <button 
              className="btn btn-white dropdown-toggle shadow-sm" 
              type="button" 
              id="dropdownMenuButton" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
              style={{ 
                maxWidth: '200px', 
                height: '33px', 
                backgroundColor: 'white', 
                color: 'gray',
                border: '1px solid white',
                display: 'flex',
                alignItems: 'center',
                fontSize: '14px',
                // marginLeft: "16px"
              }}
            >
              {selectedCategories.length === 0 
                ? "All Categories" 
                : `Selected (${selectedCategories.length})`}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {categories.map((cat, idx) => (
                <li key={idx}>
                  <div className="dropdown-item">
                    <div className="form-check">
                      <input 
                        className="form-check-input" 
                        type="checkbox" 
                        value={cat} 
                        id={`category-${idx}`}
                        checked={selectedCategories.includes(cat)}
                        onChange={handleCategoryChange}
                      />
                      <label className="form-check-label" htmlFor={`category-${idx}`}>
                        {cat}
                      </label>
                    </div>
                  </div>
                </li>
              ))}
              {selectedCategories.length > 0 && (
                <li>
                  <div 
                    className="dropdown-item text-primary" 
                    style={{cursor: 'pointer'}}
                    onClick={() => setSelectedCategories([])}
                  >
                    Clear All
                  </div>
                </li>
              )}
            </ul>
          </div>
          <div
            className="d-flex align-items-center shadow-sm rounded-2"
            style={{
              maxWidth: '250px',
              marginLeft: 15,
              backgroundColor: 'white',
              height: '33px',
              padding: '0 8px',
            }}
          >
            <input
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{
                height: '33px',
                backgroundColor: '#FFFFFF',
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
                padding: 0,
                margin: 0,
                flex: 1,
                color: 'black',
              }}
            />
            <SearchIcon style={{ height: '12px', width: '12px', color: '#1a7a73' }} />
          </div>

          
        </div>
      </div>

      <div className="branch-main-container">
  <div className="announcements-grid" style={{ height: "379px" }}>
    {/* BRANCHES */}
    <div
      className="custom-border scroll-container"
      style={{
        // Hide if no search matches AND search is active
        display: 
          (selectedCategories.length === 0 || selectedCategories.includes('BRANCHES')) &&
          (branches.length > 0 || !searchText) 
            ? 'block' 
            : 'none',
      }}
    >
      <h5 className="white-background">BRANCHES</h5>
      {branches.length > 0 ? (
        branches.map((branch, index) => (
          <AnnouncementCard key={index} item={branch} category="BRANCHES" />
        ))
      ) : (
        <div className="no-data text-center p-3" style={{ marginTop: "120px" }}>
          {searchText ? "No matching results" : "No data to show"}
        </div>
      )}
    </div>

    {/* INCIDENTS */}
    <div
      className="custom-border scroll-container"
      style={{
        display: 
          (selectedCategories.length === 0 || selectedCategories.includes('INCIDENTS')) &&
          (incidents.length > 0 || !searchText) 
            ? 'block' 
            : 'none',
      }}
    >
      <h5 className="white-background">INCIDENTS</h5>
      {incidents.length > 0 ? (
        incidents.map((incident, index) => (
          <AnnouncementCard key={index} item={incident} category="INCIDENTS" />
        ))
      ) : (
        <div className="no-data text-center p-3" style={{ marginTop: "120px" }}>
          {searchText ? "No matching results" : "No data to show"}
        </div>
      )}
    </div>

    {/* ATMS */}
    <div
      className="custom-border scroll-container"
      style={{
        display: 
          (selectedCategories.length === 0 || selectedCategories.includes('ATMS')) &&
          (atm.length > 0 || !searchText) 
            ? 'block' 
            : 'none',
      }}
    >
      <h5 className="white-background">ATMS</h5>
      {atm.length > 0 ? (
        atm.map((atmItem, index) => (
          <AnnouncementCard key={index} item={atmItem} category="ATMS" />
        ))
      ) : (
        <div className="no-data text-center p-3" style={{ marginTop: "120px" }}>
          {searchText ? "No matching results" : "No data to show"}
        </div>
      )}
    </div>

    {/* STAFF */}
    <div
      className="custom-border scroll-container"
      style={{
        display: 
          (selectedCategories.length === 0 || selectedCategories.includes('STAFF')) &&
          (staff.length > 0 || !searchText) 
            ? 'block' 
            : 'none',
      }}
    >
      <h5 className="white-background">STAFF</h5>
      {staff.length > 0 ? (
        staff.map((staffItem, index) => (
          <AnnouncementCard key={index} item={staffItem} category="STAFF" />
        ))
      ) : (
        <div className="no-data text-center p-3" style={{ marginTop: "120px" }}>
          {searchText ? "No matching results" : "No data to show"}
        </div>
      )}
    </div>
  </div>
</div>

      {/* Card Details Modal */}
      <div className={`modal fade ${showCardModal ? 'show' : ''}`} 
           style={{ display: showCardModal ? 'block' : 'none' }} 
           tabIndex="-1" 
           role="dialog"
           aria-hidden={!showCardModal}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header" >
              <h5 className="modal-title" >
                {selectedCard?.categoryName} - {selectedCard?.subCategoryName}
              </h5>
              <button type="button" className="btn-close" onClick={handleCardModalClose}  aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {selectedCard && (
                <>
                  <div className="mb-3">
                    <h6 className="fw-bold">Title</h6>
                    <p style={{color:'black',fontFamily:'Poppins, sans-serif',fontSize:'14px'}}>{selectedCard.title}</p>
                  </div>
                  <div className="mb-3">
                    <h6 className="fw-bold">Description</h6>
                    <p style={{color:'black',fontFamily:'Poppins, sans-serif',fontSize:'14px'}}>{selectedCard.description}</p>
                  </div>
                  <div className="mb-3">
                    <h6 className="fw-bold">Active Date</h6>
                    <p style={{color:'black',fontFamily:'Poppins, sans-serif',fontSize:'14px'}}>{formatDate(selectedCard.activeDate)}</p>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* Modal backdrop */}
      {showCardModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default NewAnnouncementsForm;